import React from 'react';
import { ReactComponent as ScanSVG } from './scan.svg';

export default function ScanIcon({width = 16, height = 16, color = 'currentColor'})
{
  return (
    <ScanSVG
      width={width}
      height={height}
      style={{stroke: color}}
    />
  );
}